/**
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { c as createSVGComponent } from '../utils-9450cd75.js';
import '@carbon/icon-helpers';
import 'vue';

const ChevronRight20 = createSVGComponent('ChevronRight20', {
  "xmlns": "http://www.w3.org/2000/svg",
  "viewBox": "0 0 32 32",
  "fill": "currentColor",
  "width": 20,
  "height": 20
}, [{
  "elem": "path",
  "attrs": {
    "d": "M22 16L12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z"
  }
}]);

export { ChevronRight20 as default };
